import { useCallback, useReducer } from "react";
function copyToClipboardReducer(_, action) {
  return action;
}
function getError(e) {
  return e instanceof Error ? e : new Error("unknown error");
}
const defaultConfig = {};
function useCopyToClipboard(config = defaultConfig) {
  const { onCopy, onDone, onError, onSuccess } = config;
  const [state, dispatch] = useReducer(copyToClipboardReducer, {
    isError: false,
    value: ""
  });
  const copy = useCallback(
    async function copyToClipboard(text) {
      onCopy?.(text);
      if (!window.isSecureContext || !navigator?.clipboard) {
        dispatch({
          error: new Error("clipboard is not available"),
          isError: true,
          value: ""
        });
        return false;
      }
      try {
        await navigator.clipboard.writeText(text);
        dispatch({ isError: false, value: text });
        onSuccess?.(text);
        return true;
      } catch (e) {
        const error = getError(e);
        dispatch({ error, isError: true, value: "" });
        onError?.(error);
        return false;
      } finally {
        onDone?.(text);
      }
    },
    [onCopy, onDone, onError, onSuccess]
  );
  return [state, copy];
}
export {
  useCopyToClipboard
};
//# sourceMappingURL=useCopyToClipboard.js.map
